import type * as Types from '../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProjectReportCompanyQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ProjectReportCompanyQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly id: string, readonly company?: { readonly __typename?: 'AccountsCompany', readonly id: string, readonly uuid: string, readonly name: string } | null } | null };


export const ProjectReportCompanyDocument = gql`
    query ProjectReportCompany($id: ID!) {
  currentUser {
    id
    company(id: $id) {
      id
      uuid
      name
    }
  }
}
    `;

/**
 * __useProjectReportCompanyQuery__
 *
 * To run a query within a React component, call `useProjectReportCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectReportCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectReportCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectReportCompanyQuery(baseOptions: Apollo.QueryHookOptions<ProjectReportCompanyQueryPage, ProjectReportCompanyQueryVariables> & ({ variables: ProjectReportCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectReportCompanyQueryPage, ProjectReportCompanyQueryVariables>(ProjectReportCompanyDocument, options);
      }
export function useProjectReportCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectReportCompanyQueryPage, ProjectReportCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectReportCompanyQueryPage, ProjectReportCompanyQueryVariables>(ProjectReportCompanyDocument, options);
        }
export function useProjectReportCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectReportCompanyQueryPage, ProjectReportCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectReportCompanyQueryPage, ProjectReportCompanyQueryVariables>(ProjectReportCompanyDocument, options);
        }
export type ProjectReportCompanyQueryHookResult = ReturnType<typeof useProjectReportCompanyQuery>;
export type ProjectReportCompanyLazyQueryHookResult = ReturnType<typeof useProjectReportCompanyLazyQuery>;
export type ProjectReportCompanySuspenseQueryHookResult = ReturnType<typeof useProjectReportCompanySuspenseQuery>;
export type ProjectReportCompanyQueryResult = Apollo.QueryResult<ProjectReportCompanyQueryPage, ProjectReportCompanyQueryVariables>;